import { render, staticRenderFns } from "./a35.vue?vue&type=template&id=1208c16c&scoped=true"
import script from "./a35.vue?vue&type=script&lang=js"
export * from "./a35.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1208c16c",
  null
  
)

export default component.exports